import { useLang } from "@/lib/i18n";
import { AlertCircle, Inbox } from "lucide-react";

export function Eyebrow({ children, light = false }) {
  return <p className={`eyebrow ${light ? "!text-gold" : ""}`}>{children}</p>;
}

export function PageHead({ eyebrow, title, sub, testid }) {
  return (
    <div className="mx-auto max-w-3xl text-center" data-testid={testid}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="mt-3 font-display text-4xl font-bold text-marine sm:text-5xl">{title}</h1>
      {sub && <p className="mt-4 text-base text-slate-500 md:text-lg">{sub}</p>}
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-lg bg-slate-200/70 ${className}`} />;
}

export function CardSkeleton({ count = 6 }) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="mg-card p-6">
          <Skeleton className="h-11 w-11 rounded-lg" />
          <Skeleton className="mt-4 h-5 w-2/3" />
          <Skeleton className="mt-3 h-4 w-full" />
          <Skeleton className="mt-2 h-4 w-5/6" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ message, testid = "empty-state" }) {
  const { t } = useLang();
  return (
    <div className="mg-card mx-auto flex max-w-lg flex-col items-center gap-3 p-10 text-center" data-testid={testid}>
      <Inbox className="h-10 w-10 text-slate-300" />
      <p className="text-sm text-slate-500">{message || t("common.empty")}</p>
    </div>
  );
}

export function ErrorState({ onRetry, testid = "error-state" }) {
  const { t } = useLang();
  return (
    <div className="mg-card mx-auto flex max-w-lg flex-col items-center gap-3 p-10 text-center" data-testid={testid}>
      <AlertCircle className="h-10 w-10 text-red-300" />
      <p className="text-sm text-slate-500">{t("common.error")}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-outline" data-testid="retry-button">
          {t("common.retry")}
        </button>
      )}
    </div>
  );
}
